import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TabForumPageRoutingModule } from './tab-forum-routing.module';
import { TabForumPage } from './tab-forum.page';
import { FooterComponentModule } from '../components/footer-component.module';
import { ComunityComponent } from './comunity/comunity.component';
import { ForumComponent } from './forum/forum.component';
import { MyFilterPipeModule } from '../pipe/myfilter-pipe.module';
import { PublicidadPipeModule } from '../pipe/publicidad-pipe.module';
import { ForosPipe } from '../pipe/Forospipe.pipe';
import { SectionAdvertisementsComponent } from '../components/section-advertisements/section-advertisements.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TabForumPageRoutingModule,
    FooterComponentModule,
    MyFilterPipeModule,
    PublicidadPipeModule,
  ],
  declarations: [TabForumPage, ComunityComponent, ForumComponent, ForosPipe, SectionAdvertisementsComponent]
})
export class TabForumPageModule {}
